import { render } from "./HubList.vue?vue&type=template&id=1b2f9864"
import script from "./HubList.vue?vue&type=script&lang=js"
export * from "./HubList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__